
import axios from 'axios'

export const inviteCarrier = (obj) => {
    const url = `${window.MYQLOCX_API}/subject/admin/carriers/invite`
    return axios.post(url, obj)
}